import { Component } from 'react'
import $ from 'jquery'
import batchModalTemplate from 'templates/batch/search.pug'
import storeBatchTemplate from 'templates/store/batch.pug'

import componentLoader from 'scripts/component-loader'

const PROPS_TO_CHECK_ON_UPDATE = ['lm', 'storeSlug', 'limit']

class BatchSearchButton extends Component {
  componentDidMount () {
    this.updateModal()
  }

  componentDidUpdate (prevProps) {
    const shouldUpdateModal = PROPS_TO_CHECK_ON_UPDATE.some((prop) => {
      return this.props[prop] !== prevProps[prop]
    })

    if (shouldUpdateModal) {
      this.updateModal()
    }
  }

  componentWillUnmount () {
    if (this.$modal) {
      this.$modal.destroy()
    }
  }

  updateModal = () => {
    const { lm, storeSlug, limit } = this.props

    this.$modal = $(batchModalTemplate({ lm, storeSlug, limit }))
      .append(storeBatchTemplate({ lm, storeSlug }))
      .modal()
      .data('modal')

    componentLoader(this.$modal.$content.find('[data-component]'))
  }

  showModal = () => {
    this.$modal.show()
  }

  render () {
    return (
      <button
        className="button-hollow button-hollow-primary"
        onClick={this.showModal}>
        Ver Lote
      </button>
    )
  }
}

export default BatchSearchButton
